import { createSelector } from "reselect";

export const getSubscription = createSelector( state => state.subscription.logged, logged => logged.subscription );
export const error = state => state.subscription.logged.error;

export const getHoldingFunnels = state => state.subscription.holdingFunnels.data;
export const isLoadingHoldingFunnels = state => state.subscription.holdingFunnels.loading;